import { Link } from "react-router-dom";
import ContactBlock from "../components/ContactBlock";
import { heroButtons, heroButtonThemes } from "../config/siteConfig";
import ProfileImage from "../images/nathancolesjr.png";
import "../styles/Home.css";

const audienceCards = [
  {
    eyebrow: "Artists / Labels / Managers",
    title: "Music videos and visual direction.",
    body: "For artists who need a director, a reel, or a full visual.",
    to: "/work",
    cta: "View Work",
  },
  {
    eyebrow: "Brands / Creators",
    title: "Project-based content.",
    body: "For campaigns, launches, branded videos, promos, and short-form content.",
    to: "/work",
    cta: "View Work",
  },
  {
    eyebrow: "Businesses",
    title: "Business content.",
    body: "For businesses that want stronger content, consistent posting, and a better online presence.",
    to: "/business",
    cta: "View Business Content",
  },
];

function Home() {
  const getHeroButtonStyle = (variant) => ({
    ...heroButtonThemes[variant],
    "--hero-button-width": heroButtons.widthDesktop,
    "--hero-button-width-mobile": heroButtons.widthMobile,
    "--hero-button-radius": heroButtons.radius,
  });

  return (
    <main className="home" id="top">
      <section className="hero section">
        <div className="hero__visualWrap">
          <div className="hero__visual">
            <div className="hero__visualAccent" />
            <img className="hero__portrait" src={ProfileImage} alt="Nathan Coles Jr." />
          </div>
        </div>

        <div className="hero__content">
          <div className="hero__identity">
            <h1>Nathan Coles Jr.</h1>
            <h2>Director, editor, and content creator.</h2>
          </div>

          <div className="hero__summaryWrap">
            <p className="hero__summary">
              I make music videos, branded content, and short-form social media content.
            </p>
          </div>

          <div className="hero__actions">
            <Link
              className="button heroButton"
              to={heroButtons.brand.href}
              style={getHeroButtonStyle(heroButtons.brand.variant)}
            >
              {heroButtons.brand.label}
            </Link>
            <Link
              className="button heroButton"
              to={heroButtons.artist.href}
              style={getHeroButtonStyle(heroButtons.artist.variant)}
            >
              {heroButtons.artist.label}
            </Link>
          </div>
        </div>
      </section>

      <section className="section audienceSection">
        <div className="sectionHeading">
          <h2>What I do.</h2>
        </div>

        <div className="audienceGrid">
          {audienceCards.map((card) => (
            <article key={card.title} className="audienceCard">
              <div className="audienceCard__body">
                <p className="eyebrow">{card.eyebrow}</p>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </div>
              <Link className="button audienceCard__button" to={card.to}>
                {card.cta}
              </Link>
            </article>
          ))}
        </div>
      </section>

      <section className="section proofStrip">
        <div className="proofStrip__content">
          <h2>0 to 20,000 followers in 2 months.</h2>
          <p>1,000+ short-form posts. 500K to 2.5M views every 30 days.</p>
        </div>
        <Link className="button button--secondary proofStrip__button" to="/business">
          View Business Content
        </Link>
      </section>

      <ContactBlock />
    </main>
  );
}

export default Home;
